import { paginate, response } from 'mocks/helpers';
import { compliances } from 'mocks/data/compliance';
import type { Server } from 'miragejs';

export const complianceEndpoints = (server: Server) => {
  server.get(`/Compliance/:id`, (schema, request) => {
    const { id } = request.params;

    const complianceById = compliances.find(compliance => compliance.Id.toString() === id);

    if (!complianceById) {
      return response(request.url, undefined, {
        statusCode: 404,
        body: {
          code: `Could not find a compliance certificate with the id of ${id}`,
          status: 'Bad Request',
        },
      });
    }
    return response(request.url, undefined, { body: complianceById });
  });
  server.get(`/Compliances`, (schema, request) => {
    const url = new URL(request.url);
    const perPage = url.searchParams.get('perPage') || 10;
    const page = url.searchParams.get('page') || 1;

    if (perPage || page) {
      const paginated = paginate({
        items: compliances,
        perPage: Number(perPage),
        page: Number(page),
      });

      return response(request.url, undefined, { body: paginated });
    }

    return response(request.url, undefined, { body: compliances });
  });
};
